import { Controller } from 'stimulus';
import Recorder from 'recorder-js';

import Requests from '../requests.js';

export default class extends Controller {
  static targets = [
    // State 1 elements
    'welcomeText',
    'continueButton',
    // State 2 elements
    'delayText',
    'getStartedButton',
    // State 3 elements
    'promptText',
    'timer',
    'recordingText',
    // State 4 elements
    'state4',
    // State 5 elements
    'state5',
    'audioPlayer',
    'finishButton',
    'endText',
    'audioButton',
  ];

  audioRecorder = null;
  stream = null;
  chunks = [];
  intervalId = 0;
  delayTime = 10;
  duration = this.data.get('duration');
  audioUrl = null;

  recorder = null;
  isRecording = 'inactive';
  blob = null;

  // State 2 transition functions
  transitionToState2 = () => {
    if (this.audioAvailable) this.requestMicrophoneAccess();
  };

  get audioAvailable() {
    return navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
  }

  requestMicrophoneAccess = () => {
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    this.recorder = new Recorder(audioContext);

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(this.showState2Instructions)
      .catch(this.handleNoMicrophoneAccess);
  };

  showState2Instructions = (stream) => {
    this.welcomeTextTarget.classList.add('hidden');
    this.delayTextTarget.classList.remove('hidden');
    this.continueButtonTarget.classList.add('hidden');
    this.getStartedButtonTarget.classList.remove('hidden');
    this.stream = stream;
  };

  handleNoMicrophoneAccess = (err) => {
    console.log(
      'Could not get access to microphone due to following getUserMedia error: ',
      err,
    );
  };

  // State 3 transition function
  transitionToState3 = async () => {
    this.delayTextTarget.classList.add('hidden');
    this.getStartedButtonTarget.classList.add('hidden');
    this.promptTextTarget.classList.remove('hidden');

    const assignmentId = this.data.get('assignmentId')
    await Requests.assignmentViewed(assignmentId)

    this.timerTarget.classList.remove('hidden');

    this.timerTarget.textContent = this.delayTime;

    this.intervalId = setInterval(this.countDownToZeroForDelay, 1000);
  };

  countDownToZeroForDelay = () => {
    if (this.delayTime) {
      this.delayTime -= 1;
      this.timerTarget.textContent = this.delayTime;
    } else {
      clearInterval(this.intervalId);
      this.startRecording();
    }
  };

  startRecording = () => {
    this.recorder.init(this.stream)
    this.recorder.start().then(() => {
      (this.isRecording = true);
    })

    this.recordingTextTarget.classList.remove('hidden');

    this.intervalId = setInterval(this.countDownToZeroForPrompt, 1000);

  };

  recordAudio = ({ data }) => this.chunks.push(data);

  countDownToZeroForPrompt = () => {
    if (this.duration) {
      this.duration -= 1;
      this.updateTimerDisplay();
    } else {
      clearInterval(this.intervalId);
      this.transitionToState4();
    }
  };

  updateTimerDisplay = () => {
    const duration = this.duration;
    const minutes = Math.floor(duration / 60).toString();
    const seconds = (duration % 60).toString();
    const paddedSeconds = seconds.padStart(2, '0');

    this.timerTarget.textContent = `${minutes}:${paddedSeconds}`;
  };

  submitAudioRecording = (attemptsLeft) => {
    if (attemptsLeft) {
      const assignmentId = this.data.get('assignmentId');
      // const audio = new Blob(this.blob, { type: 'audio/ogg; codecs=opus' });
      const formData = new FormData();
      formData.append('audio', this.blob);
      return Requests.submitAnswer(formData, assignmentId)
        .then((answer) => {
          console.log('Audio persisted, and url received: ', answer.audioUrl);
          this.audioPlayerTarget.src = answer.audioUrl;
          this.state4Target.classList.add("hidden")
          this.state5Target.classList.remove("hidden")
        })
        .catch((error) => {
          console.error(error);
          this.submitAudioRecording(attemptsLeft - 1);
        });
    } else {
      alert(
        'Something has gone TERRIBLY wrong! Could not submit audio recording',
      );
    }
  };
  // State 4
  transitionToState4 = () => {
    this.recorder.stop().then(({ blob }) => {
      this.blob = blob
      this.submitAudioRecording(3)
    })

    this.recordingTextTarget.classList.add('hidden');
    this.timerTarget.classList.add('hidden');

    this.state4Target.classList.remove('hidden');
  };

  finish = () => {
    this.audioPlayerTarget.remove();
    this.state5Target.classList.add('hidden');

    this.promptTextTarget.classList.add('hidden');
    this.endTextTarget.classList.remove('hidden');
    Requests.sendCompletionEmail(this.data.get('assignmentId'));
  };
}
